import * as Stimulus from "@hotwired/stimulus"

export class InviteDeclineController extends Stimulus.Controller {
    connect() {
        this.submit = () => {
            if (this.submitted || document.documentElement.hasAttribute("data-turbo-preview")) return;
            this.submitted = true;
            this.element.requestSubmit();
        };
        // A prerendered page must not respond before the creator opens it.
        if (document.prerendering) {
            document.addEventListener("prerenderingchange", this.submit, { once: true });
        } else {
            this.frame = requestAnimationFrame(this.submit);
        }
    }

    disconnect() {
        cancelAnimationFrame(this.frame);
        document.removeEventListener("prerenderingchange", this.submit);
    }
}
